$(function() {
    window.setTimeout(function() {
        var $autoscroll = $('#autoscroll');
        if ($autoscroll.length > 0) {
            $('html, body').animate({
                scrollTop: $autoscroll.offset().top
            }, 'slow');
        }
    }, 500);
});
